import { NavigationClient, NavigationOptions } from '@azure/msal-browser';
import { NavigateFunction } from 'react-router-dom';

/** MSAL navigation client that routes MSAL's in-app navigations through React Router. */
export class CustomNavigationClient extends NavigationClient {
  private navigate?: NavigateFunction;

  async navigateInternal(url: string, options: NavigationOptions) {
    if (!this.navigate) {
      return await super.navigateInternal(url, options);
    }

    const relativePath = url.replace(window.location.origin, '');
    this.navigate(relativePath, { replace: options.noHistory });
    return false;
  }

  setNavigate(navigate?: NavigateFunction) {
    this.navigate = navigate;
  }
}
